module.exports = __webpack_public_path__ + "static/img/1679716661117.b245fb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/1679716661117.png
// module id = 4C43
// module chunks = 1